// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-CardA":"CardCommon_dpu-detail-CardA__auVAF"};